define([
    'text!./templates/button-select-term.html',
], (templateStr) => {
    return () => ({
        restrict: 'E',
        template: templateStr,
        scope: {
            term: '=',
            disabledIf: '=?',
        },
    });
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/ButtonSelectTerm.js